export enum PermissionPagesEnum {
    DashboardAdministrative = 101,
    FinancialOrders = 201,
    FinancialCards = 202,
    ManagementBeneficiaries = 301,
    ManagementConfigs = 302,
    ManagementUsers = 303,
    ManagementPrivileges = 304,
    SecurityAudit = 401,
}